import { Toast } from './Toast.js';

export function openStoryCardModal(movie) {
  const backdrop = document.createElement('div');
  backdrop.className = 'sheet-backdrop active';

  backdrop.innerHTML = `
    <div class="bottom-sheet" style="max-width: 480px; text-align: center;" role="dialog">
      <div class="sheet-handle"></div>

      <div style="margin-bottom: var(--space-md);">
        <h3 style="font-size: 1.25rem; font-weight: 800; margin-bottom: 2px;">Share Story Card</h3>
        <p style="color: var(--text-secondary); font-size: 0.85rem;">Formatted 9:16 for WhatsApp Status and Instagram Stories</p>
      </div>

      <!-- Canvas Preview Wrap -->
      <div style="width: 100%; max-width: 320px; aspect-ratio: 9 / 16; margin: 0 auto var(--space-md) auto; border-radius: var(--radius-md); overflow: hidden; box-shadow: var(--shadow-lg); border: 2px solid var(--border-gold); background: #0a0b0e;">
        <canvas id="story-canvas" width="540" height="960" style="width: 100%; height: 100%; display: block;"></canvas>
      </div>

      <div style="display: flex; gap: var(--space-sm); justify-content: center; flex-wrap: wrap;">
        <button id="download-card-btn" class="btn-primary clickable-item" style="flex: 1; min-width: 140px;">
          ⬇ Download PNG
        </button>
        <button id="share-card-btn" class="btn-secondary clickable-item" style="flex: 1; min-width: 140px;">
          📲 Share to Story
        </button>
      </div>

      <button id="close-story-btn" class="btn-secondary clickable-item" style="width: 100%; margin-top: var(--space-xs); padding: 8px;">
        Close
      </button>
    </div>
  `;

  const canvas = backdrop.querySelector('#story-canvas');
  const ctx = canvas.getContext('2d');

  function renderCard() {
    const w = 540;
    const h = 960;

    // Background gradient
    const bgGrad = ctx.createLinearGradient(0, 0, 0, h);
    bgGrad.addColorStop(0, '#0f1117');
    bgGrad.addColorStop(0.5, '#12141a');
    bgGrad.addColorStop(1, '#08090c');
    ctx.fillStyle = bgGrad;
    ctx.fillRect(0, 0, w, h);

    // Decorative golden accent bars
    ctx.fillStyle = '#f59e0b';
    ctx.fillRect(40, 40, w - 80, 3);

    // Header branding
    ctx.font = 'bold 16px sans-serif';
    ctx.fillStyle = '#f59e0b';
    ctx.textAlign = 'center';
    ctx.fillText('CINEMAHALA • සිනමාහල', w / 2, 75);

    ctx.font = '12px sans-serif';
    ctx.fillStyle = '#94a3b8';
    ctx.fillText('THE HOME OF SRI LANKAN CINEMA', w / 2, 95);

    // Poster Image
    const img = new Image();
    img.crossOrigin = 'anonymous';
    img.onload = () => {
      // Draw poster rounded
      const pw = 360;
      const ph = 460;
      const px = (w - pw) / 2;
      const py = 120;

      ctx.save();
      ctx.beginPath();
      ctx.roundRect(px, py, pw, ph, 16);
      ctx.clip();
      ctx.drawImage(img, px, py, pw, ph);
      ctx.restore();

      // Poster subtle border
      ctx.strokeStyle = 'rgba(245, 158, 11, 0.4)';
      ctx.lineWidth = 2;
      ctx.beginPath();
      ctx.roundRect(px, py, pw, ph, 16);
      ctx.stroke();

      drawTextContent();
    };
    img.onerror = () => {
      drawTextContent();
    };
    img.src = movie.poster;

    function drawTextContent() {
      // Title
      ctx.font = 'bold 30px sans-serif';
      ctx.fillStyle = '#ffffff';
      ctx.textAlign = 'center';
      ctx.fillText(movie.title, w / 2, 630);

      // Sinhala Title
      if (movie.sinhalaTitle) {
        ctx.font = 'bold 20px sans-serif';
        ctx.fillStyle = '#f59e0b';
        ctx.fillText(movie.sinhalaTitle, w / 2, 665);
      }

      // Meta info
      ctx.font = '14px sans-serif';
      ctx.fillStyle = '#94a3b8';
      const meta = `${movie.year} • Dir: ${movie.director ? movie.director.name : 'Cinema'}`;
      ctx.fillText(meta, w / 2, 695);

      // Rating Pill
      const pillW = 140;
      const pillH = 34;
      const pillX = (w - pillW) / 2;
      const pillY = 720;

      ctx.fillStyle = 'rgba(245, 158, 11, 0.15)';
      ctx.beginPath();
      ctx.roundRect(pillX, pillY, pillW, pillH, 17);
      ctx.fill();

      ctx.strokeStyle = '#f59e0b';
      ctx.lineWidth = 1.5;
      ctx.stroke();

      ctx.font = 'bold 15px sans-serif';
      ctx.fillStyle = '#fbbf24';
      ctx.fillText(`★ ${movie.rating || 5.0} / 5.0`, w / 2, pillY + 22);

      // Quote or tagline
      const quote = (movie.quotes && movie.quotes[0])
        ? `"${movie.quotes[0].quote.substring(0, 70)}..."`
        : '"A timeless masterpiece of Sri Lankan cinema."';

      ctx.font = 'italic 13px sans-serif';
      ctx.fillStyle = '#cbd5e1';
      ctx.fillText(quote, w / 2, 790);

      // Footer branding
      ctx.fillStyle = 'rgba(255, 255, 255, 0.08)';
      ctx.fillRect(40, 890, w - 80, 1);

      ctx.font = '12px sans-serif';
      ctx.fillStyle = '#64748b';
      ctx.fillText('cinemahala.pages.dev', w / 2, 920);
    }
  }

  renderCard();

  const downloadBtn = backdrop.querySelector('#download-card-btn');
  downloadBtn.addEventListener('click', () => {
    canvas.toBlob((blob) => {
      if (!blob) return;
      const url = URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = `${movie.id}-story.png`;
      a.click();
      URL.revokeObjectURL(url);
      Toast.show('Story card downloaded!', 'success');
    });
  });

  const shareBtn = backdrop.querySelector('#share-card-btn');
  shareBtn.addEventListener('click', () => {
    canvas.toBlob(async (blob) => {
      if (!blob) return;
      const file = new File([blob], `${movie.id}-story.png`, { type: 'image/png' });
      if (navigator.canShare && navigator.canShare({ files: [file] })) {
        try {
          await navigator.share({
            title: `${movie.title} on CinemaHala`,
            text: `Check out ${movie.title} (${movie.year}) on CinemaHala!`,
            files: [file]
          });
          Toast.show('Shared successfully!', 'success');
        } catch (e) {
          // User canceled share
        }
      } else {
        // Fallback: Copy direct URL
        navigator.clipboard.writeText(window.location.href);
        Toast.show('Movie link copied to clipboard!', 'success');
      }
    });
  });

  function close() {
    backdrop.classList.remove('active');
    setTimeout(() => backdrop.remove(), 250);
  }

  backdrop.querySelector('#close-story-btn').addEventListener('click', close);
  backdrop.addEventListener('click', (e) => {
    if (e.target === backdrop) close();
  });

  document.body.appendChild(backdrop);
}
